import React, { Component } from 'react';
import CTCAE_ROW_DATA from '../../../resources/ctcae6';
import './category.css';
import Result from '../result/result';

// Create unique SOC list from raw CTCAE data
const SOC_LIST_INDEX = Array.from(
    new Set(CTCAE_ROW_DATA.map(item => item.meddra_soc))
);

console.log('SOC_LIST_INDEX : ', SOC_LIST_INDEX);

class Category extends Component {

    constructor() {
        super();
        this.state = {
            step: 0,
            soc: null,
            term: null,
            note: ""
        }
    }

    selectSoc(event, soc) {
        this.setState({
            step: 1,
            soc: soc
        });
    }

    deSelectSoc(event){
        this.setState({
            step: 0,
            soc: null,
            term: null
        });
    }

    selectTerm(event, term) {
        this.setState({
            step: 2,
            term: term
        });
    }

    deSelectTerm(event){
        this.setState({
            step: 1,
            term: null
        });
    }

    handleChange = event => {
        this.setState({
            [event.target.id]: event.target.value
        });
    };

    render() {
        // console.log("row :", CTCAE_ROW_DATA.length);

        const { soc } = this.state;
        const { term } = this.state;

        let self = this;
        let infoListView = null;

        if(this.state.step === 0 ){

            infoListView = SOC_LIST_INDEX.map(data => (
                <div className="list-item" key={data} onClick={(e) => self.selectSoc(e,data)}>
                    <a>{data}</a>
                </div>
            ));

            return (
                <div className="main-content">
                    <div className="row content-header">
                        <div className="col-sm-3">
                            <div className="title">
                                <div>Select a Soc</div>
                            </div>
                        </div>
                    </div>
                    <div className="content-body">
                        <div className="list">
                            {infoListView}
                        </div>
                    </div>
                </div>
            );
        }else if(this.state.step === 1 ){

            const filteredList = CTCAE_ROW_DATA.filter(data => data.meddra_soc === soc);
            infoListView = filteredList.map(data => (
                <div className="list-item" key={data.meddra_code} onClick={(e) => self.selectTerm(e,data.ctcae_term)}>
                    <a>{data.ctcae_term}</a>
                </div>
            ));

            return (
                <div className="main-content">
                    <div className="row content-header">
                        <div className="col-sm-3">
                            <div className="title">
                                <div>Select a Term</div>
                            </div>
                        </div>
                        <div className="col-sm-9">
                            <div className="selected-category-container">
                                <div className="selected-category">
                                    <div>{soc} <a className="btn btn-danger close-button"><i className="fa fa-close" onClick={(e) => self.deSelectSoc(e)}/></a></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="content-body">
                        <div className="list">
                            {infoListView}
                        </div>
                    </div>
                </div>
            );
        }else if(this.state.step === 2 ){

            const result = CTCAE_ROW_DATA.filter(data => ((data.meddra_soc === soc) && (data.ctcae_term === term)))[0];

            console.log("props : ",this.props);
            console.log("final result : ",result);

            return (
                <div className="main-content">
                    <div className="row content-header">
                        <div className="col-sm-3">
                            <div className="title">
                                <div>Result</div>
                            </div>
                        </div>
                        <div className="col-sm-9">
                            <div className="selected-category-container">
                                <div className="selected-category">
                                    <div>{soc} <a className="btn btn-danger close-button"><i className="fa fa-close" onClick={(e) => self.deSelectSoc(e)}/></a></div>
                                </div>
                                <div className="selected-category">
                                    <div>{term} <a className="btn btn-danger close-button"><i className="fa fa-close" onClick={(e) => self.deSelectTerm(e)}/></a></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="content-body">
                        <Result result={result}/>
                    </div>
                </div>
            );
        }else{
            console.log();
            return (
                <div>No Result</div>
            );
        }
    }
}
export default Category;


// WEBPACK FOOTER //
// ./src/component/ctcae6/category/category.js